import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiMenu, HiX, HiDownload } from 'react-icons/hi';
import { API_BASE, CV_URL } from '../config';
import { useLanguage } from '../context/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDownloadCV = async () => {
    setIsOpen(false);
    const cvEndpoint = API_BASE ? `${API_BASE}/api/cv` : CV_URL;
    try {
      const response = await fetch(cvEndpoint);
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Bernard_Banda_Cv.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('CV download error:', err);
      window.open(cvEndpoint, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="logo">
        <img src="/images/portfolioIcon.jpg" alt="Portfolio" />
      </Link>

      <div className={`nav-links ${isOpen ? 'active' : ''}`}>
        <Link to="/" className="nav-link" data-tour="nav-home" onClick={() => setIsOpen(false)}>
          {t('nav.home')}
        </Link>
        <Link to="/projects" className="nav-link" data-tour="nav-projects" onClick={() => setIsOpen(false)}>
          {t('nav.projects')}
        </Link>
        <Link to="/graphic-design" className="nav-link" data-tour="nav-design" onClick={() => setIsOpen(false)}>
          {t('nav.graphicDesign')}
        </Link>
        <Link to="/certifications" className="nav-link" data-tour="nav-certifications" onClick={() => setIsOpen(false)}>
          {t('nav.certifications')}
        </Link>
        <Link to="/about" className="nav-link" data-tour="nav-about" onClick={() => setIsOpen(false)}>
          {t('nav.about')}
        </Link>
        <Link to="/contact" className="nav-link" data-tour="nav-contact" onClick={() => setIsOpen(false)}>
          {t('nav.contact')}
        </Link>
        <button type="button" onClick={handleDownloadCV} className="nav-link cv-download-link">
          <HiDownload style={{ marginRight: '0.4rem' }} /> {t('nav.cv')}
        </button>
        <LanguageSwitcher />
      </div>

      <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <HiX size={28} /> : <HiMenu size={28} />}
      </div>
    </nav>
  );
};

export default Navbar;
